/**
 * Created by Ella M a on 2020-11-12.
 * Description:
 * Expect Company and Birthday column, all columns has 'Parameter Value' and 'Data Type', 'Parameter Value' is required, and 'Data Type' is text and disabled.
 * Company column show 'Display' + 'Parameter Value', 'Display' has default value and not be blank, 'Parameter Value' is required.
 * Birthday column show 'Display' + 'Parameter Value', 'Display' has 3 items - Date Only, Month and Year, Year Only, and on the grid as Date column not string column, 'Parameter Value' is required
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { TileColumn, TileColumnDataType, TileColumnConfig, TileColumnSetting } from '../../../../tamalelibs/models/tile-column.model';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { BriefConfig } from '../../../../widgets/widgets.model';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { businessConstants } from '../../../../constants/business.constants';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';

@Component({
    selector: 'tile-contact-column-detail',
    templateUrl: './tile-contact-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileContactColumnDetailComponent implements OnInit {

    @Input()
    config: TileColumn;
    @Input()
    wholeConfig: TileModel;
    @Input()
    briefConfig: BriefConfig;
    dataTypeList = businessConstants.dataTypeList;
    displayAsList = businessConstants.displayAsList;
    displayList: Array<BriefObject>;
    isShowDisplayAs = false;
    parameterValueList: Array<BriefObject> = [];
    showDisplay = false;
    selectedDataType: BriefObject;
    selectedDisplay: BriefObject;
    selectedDisplayAs: BriefObject;
    selectedParameterValue: BriefObject;
    showDataType = true;

    ngOnInit(): void {
        if (this.config.dataType === TileColumnDataType.ENTITY) {
            this.displayList = [{ id: '0', value: 'Short Name' }, { id: '1', value: 'Long Name' }, { id: '2', value: 'Alias' }];
            this.showDisplay = true;
            this.showDataType = false;
        } else if (this.config.dataType === TileColumnDataType.DATE) {
            this.displayList = [{ id: '1', value: 'Date Only' }, { id: '2', value: 'Month and Year' }, { id: '3', value: 'Year Only' }];
            this.showDisplay = true;
            this.showDataType = false;
        }
        if (this.showDisplay) {
            this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
        }

        // entity column can not selected self as parameter value
        this.wholeConfig.columns.forEach(item => {
            if (item.dataType === TileColumnDataType.ENTITY && item.guid !== this.config.guid) {
                this.parameterValueList.push(new BriefObject(item.guid, item.title));
            }
        });
        this.selectedParameterValue = this.parameterValueList.find(item => item.id === this.config.config.parameterValue);

        if (this.showDataType) {
            this.selectedDataType = this.dataTypeList.find(item => item.value.toLowerCase() === this.config.dataType.toLowerCase());
        }

        if (this._isAddress()) {
            this.isShowDisplayAs = true;
            this.selectedDisplayAs = this.displayAsList.find(item => item.id === this.config.settings.display);
        }
    }

    onDisplayAsChange(value) {
        this.selectedDisplayAs = value;
        if (!this.config.settings) {
            this.config.settings = new TileColumnSetting();
        }
        this.config.settings.display = this.selectedDisplayAs.id;
    }

    onDisplayChange(value) {
        this.selectedDisplay = value;
        this.config.settings = new TileColumnSetting();
        this.config.settings.display = this.selectedDisplay.id;
    }

    onParameterValueChange(value) {
        this.selectedParameterValue = value;
        if (!this.config.config) {
            this.config.config = new TileColumnConfig();
        }
        this.config.config.parameterValue = this.selectedParameterValue.id;
    }

    private _isAddress(): boolean {
        let isAddress = false;
        if (this.config.name.toLowerCase() === StringLiteralsPipe.translate('general.home_address') ||
            this.config.name.toLowerCase() === StringLiteralsPipe.translate('general.work_address')) {
            isAddress = true;
        }
        return isAddress;
    }
}
